export class jobModel {
    constructor (title, company, description, salary) {
        this.title = title;
        this.company = company;
        this.description = description;
        this.salary = salary;
    }
}